import React, {Component} from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import * as TextManager from "../../../modules/languages/TextManager";
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {logout} from '../../../redux/actions/UserActions'
import {main_dashbaord_show_hello} from '../../../redux/actions/MainDashboardActions';
import {fetchTasksCount} from '../../../redux/actions/TasksActions'
import {fetchChangeSimCountNew} from '../../../redux/actions/ChangeSimActions'
import ModalInternetTv from '../../../components/ModalInternetTv';
import * as environment from "../../../modules/environment";



//const regular = `${process.env.PUBLIC_URL}/img/regular.png`;
//const kasher = `${process.env.PUBLIC_URL}/img/kasher.png`;
//const dor = `${process.env.PUBLIC_URL}/img/dor.png`;




class SidebarContent extends Component {
    static propTypes = {
        changeToDark: PropTypes.func.isRequired,
        changeToLight: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.state = {
            timerLoaded: false,
            sales: false,
            salesType: 0
        };
    }

    componentDidMount() {
        //this.checkTasks();
        this.props.dispatch(fetchTasksCount());
    }

    hideSidebar = () => {
        this.props.onClick();
    };

    showSales = (type) => {
        this.setState({sales: true, salesType: type});

    };

    showImageNewTab = (type) => {
        let tImage = new Image();
        tImage.src = type;

        let w = window.open("", '_blank');
        //w.document.write(tImage.outerHTML);
        //w.document.write("<img style='object-fit: contain;height:810px;width:100%' src='" + type + "'/>");
        w.document.write("<body style='text-align:center;'>" +
            "<hr>" +
                "<div class='box'><img id='geeks' GFG='250' style='object-fit: contain;height:810px;width:100%' src='" + type + "'/></div><hr>" +
            "<button type='button' onclick='zoomin()'>Zoom-In</button>" +
            "<button type='button' onclick='zoomout()'>Zoom-Out</button>" +
            "<script type='text/javascript'>" +
            "function zoomin() { var GFG = document.getElementById('geeks'); var currHeight = GFG.clientHeight;" +
            "GFG.style.height = (currHeight + 40) + 'px';}" +
            "function zoomout() { var GFG = document.getElementById('geeks'); var currHeight = GFG.clientHeight;" +
            "GFG.style.height = (currHeight - 40) + 'px';}" +
            "</script></body>"
            )

    };

    render() {

        if(this.props.userData && this.props.userData.data && (this.props.userData.data.isAdmin || this.props.userData.data.isManager) && !this.state.timerLoaded) {

            setInterval(this.props.dispatch(fetchTasksCount()), 5*60*1000);
            setInterval(this.props.dispatch(fetchChangeSimCountNew()), 10*60*1000);
            this.setState({timerLoaded: true});
        }

        let regular = environment.getServerBasePath() + '/cellular_route/download?id=1&hash=' + new Date().getTime();
        let kasher = environment.getServerBasePath() + '/cellular_route/download?id=2&hash=' + new Date().getTime();
        let dor = environment.getServerBasePath() + '/cellular_route/download?id=3&hash=' + new Date().getTime();

        let isSimOrder = true;
        if(this.props.userData && this.props.userData.data && this.props.userData.data.isManager) {
            if(this.props.userData.data.id !== 31 && this.props.userData.data.id !== 118 && this.props.userData.data.id !== 548 &&
                this.props.userData.data.id !== 683 && this.props.userData.data.id !== 931) {
                isSimOrder = false;
            }
        }

        let showSimNum = false;
        if(this.props.userData && this.props.userData.data && (this.props.userData.data.isAdmin || this.props.userData.data.isManager)) {
            showSimNum = true;
        }

        let isStore = false;
        if (this.props.userData && this.props.userData.data && !this.props.userData.data.isAdmin && !this.props.userData.data.isManager) {
            isStore = true;
        }

        let isAdmin = false;
        if(this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin) {
            isAdmin = true;
        }

        let showEquipment = false;
        if(isAdmin || isStore || (this.props.userData && this.props.userData.data &&
            (this.props.userData.data.id === 548 || this.props.userData.data.id === 683 || this.props.userData.data.id === 1007))){
            showEquipment = true;
        }

        let isAllSims = false;
        if(TextManager.getCurrentDashboard() === 'allsim') {
            isAllSims = true;
        }

        let isAll_Sims = false;
        if(TextManager.getCurrentDashboard() === 'all-sim') {
            isAll_Sims = true;
        }

        let isTenecom = false;
        if(TextManager.getCurrentDashboard() === 'tenecom') {
            isTenecom = true;
        }


        return (
            <div className="sidebar__content">
                <ul className="sidebar__block">
                    <SidebarLink title={TextManager.getCurrentTextResource().Dashboard.DashboardName} icon="home" route="/dashboard"/>
                    <SidebarLink title={TextManager.getCurrentTextResource().Text.sales} icon='plus-circle' route='/sales'/>

                    {
                        this.props.userData && this.props.userData.data &&
                        (this.props.userData.data.isAdmin || (this.props.userData.data.isManager &&
                            (this.props.userData.data.userType !== 5 && this.props.userData.data.userType !== 6))) &&
                        <SidebarLink title={TextManager.getCurrentTextResource().Text.providers} icon='book'
                                     route='/providers'/>
                    }

                    <SidebarLink title={TextManager.getCurrentTextResource().Customers.customers} icon='list' route='/customers'/>
                    <SidebarLink title={showSimNum ? 'בקשת החלפת סים ' + '(' + this.props.changeSimCnt + ')' : 'בקשת החלפת סים '} icon='list' route='/change_sim'/>
                    {
                        this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin &&
                        <SidebarLink title={TextManager.getCurrentTextResource().Settings.settings} icon='cog' route='/settings'/>
                    }

                    <SidebarLink title='טפסים להורדה' icon='file-empty'
                                 onClick={(e) => {
                                     e.preventDefault();
                                     window.open('https://www.s-romi.co.il/s-romi-form', '_blank');
                                 }}/>

                    {
                        this.props.userData && this.props.userData.data && isSimOrder &&
                        (this.props.userData.data.userType !== 5 && this.props.userData.data.userType !== 6) &&
                        <SidebarLink title={TextManager.getCurrentTextResource().Text.orders} icon='pencil' route='/orders'/>
                    }
                    {
                        showEquipment &&
                        <SidebarLink title='הזמנות ציוד קצה' icon='pencil' route='/equipment'/>
                    }
                    {/*<SidebarCategory title='לסינון והשוואת חבילות' icon='layers'>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%a1%d7%9c%d7%95%d7%9c%d7%a8/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה בסלולר</p>
                        </li>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%90%d7%99%d7%a0%d7%98%d7%a8%d7%a0%d7%98/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה באינטרנט</p>
                        </li>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%98%d7%9c%d7%95%d7%95%d7%99%d7%96%d7%99%d7%94/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה בטלוויזיה וטריפל</p>
                        </li>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%a7%d7%95%d7%95%d7%99-%d7%98%d7%9c%d7%a4%d7%95%d7%9f/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה בקווים נייחים</p>
                        </li>
                    </SidebarCategory>*/}
                    {
                        this.props.userData && this.props.userData.data && (this.props.userData.data.isAdmin || this.props.userData.data.isManager) &&
                        <SidebarLink title={'משימות ' + '(' + this.props.tasksCnt + ')'} icon='calendar-full' route='/tasks'/>
                    }
                    {
                        this.props.userData && this.props.userData.data &&
                        (this.props.userData.data.isAdmin || this.props.userData.data.id === 548 || this.props.userData.data.id === 683) &&
                        <SidebarLink title='לוז שבועי לסוכני השטח' icon='gift' route='/prize'/>
                    }
                    {
                        this.props.userData && this.props.userData.data && (this.props.userData.data.isAdmin ||
                            this.props.userData.data.id === 99 || this.props.userData.data.id === 807 || this.props.userData.data.id === 633) &&
                        <SidebarLink title='סטטיסטיקה' icon='chart-bars' route='/managers_stats'/>
                    }
                    {
                        this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin &&
                        <SidebarLink title='חנויות שהורידו פעילות' icon='chart-bars' route='/sales_stats'/>
                    }
                    {
                        this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin &&
                        <SidebarLink title='עסקאות שנמחקו' icon='chart-bars' route='/deleted_deals'/>
                    }
                    {/*
                        this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin &&
                        <SidebarLink title='היסטוריית המשתמשים' icon='chart-bars' route='/users_history'/>
                    */}
                    {
                        this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin &&
                        <SidebarLink title='פעולות אוטומציה' icon='chart-bars' route='/auto_stat'/>
                    }
                    {/*
                        this.props.userData && this.props.userData.data && this.props.userData.data.id === 108 &&
                        <SidebarLink title='test' icon='chart-bars' route='/test'/>
                    */}
                </ul>
                {!isAll_Sims && !isAllSims && !isTenecom && <ul className='sidebar__block'>
                    <div className='res-sphere'>
                        <div className="sphere-txt">
                            לצפיה במסלולי סלולר <br/><p></p><br/><p></p><br/>
                            <p onClick={() => this.showImageNewTab(regular)}
                               style={{fontWeight: 'bold', color: '#1ABB10', textDecoration: 'underline', cursor: 'pointer'}}>  רגיל
                                <p onClick={(e) => {
                                    e.stopPropagation();
                                    this.showImageNewTab(kasher)
                                }}
                                   style={{fontWeight: 'bold', display:'inline', marginRight: '20%', color: '#29DF1E'}}> כשר
                                    <p onClick={(e) => {
                                        e.stopPropagation();
                                        this.showImageNewTab(dor)
                                    }}
                                       style={{fontWeight: 'bold', display:'inline', marginRight: '20%', color: '#29DF1E'}}>דור 5</p>
                                </p>
                            </p>
                            <p></p><br/>
                            <p></p><br/>
                            <ModalInternetTv color='primary'>
                                <p style={{fontWeight: 'bold', fontSize: 'larger', color: '#f50c18', textDecoration: 'underline', cursor: 'pointer'}}>  אינטרנט וטיוי
                                </p>
                            </ModalInternetTv>
                        </div>
                    </div>
                </ul>}
                {/*<ul className='sidebar__block'>
                    <div className='res-sphere'>
                        <div className="sphere-txt">
                            לצפיה במסלולי סלולר <br/><p></p><br/><p></p><br/>
                            <p onClick={() => this.showSales(1)}
                               style={{fontWeight: 'bold', color: '#1ABB10', textDecoration: 'underline', cursor: 'pointer'}}>  רגיל
                                <p onClick={(e) => {
                                    e.stopPropagation();
                                    this.showSales(2)
                                }}
                                   style={{fontWeight: 'bold', display:'inline', marginRight: '20%', color: '#29DF1E'}}> כשר
                                    <p onClick={(e) => {
                                        e.stopPropagation();
                                        this.showSales(3)
                                    }}
                                       style={{fontWeight: 'bold', display:'inline', marginRight: '20%', color: '#29DF1E'}}>דור 5</p>
                                </p>
                            </p>
                        </div>
                    </div>
                    <style>
                        {`
                        .modal .modal-dialog {
                        max-width: 45%;
                        }
                        .modal .modal-content {
                         padding: 5px 10px 5px 10px;
                        }
                        `}
                    </style>
                    {this.state.sales &&
                    <ModalCellularDeals color='primary'
                               approve={() => this.setState({sales: false})}
                               message={<img src={this.state.salesType === 1 ? regular: this.state.salesType === 2 ? kasher : dor} alt="catalog-item-img" className="catalog-item__img" style={{objectFit: 'contain'}}/>}>
                    </ModalCellularDeals>}
                </ul>*/}
                <ul className="sidebar__block">
                    <SidebarLink title={TextManager.getCurrentTextResource().Text.LogOut} icon='exit' route='/dashboard'
                                 onClick={()=>{ this.props.dispatch(logout());
                                                this.props.dispatch(main_dashbaord_show_hello())}}/>
                </ul>
            </div>
        );
    }
}

export default withRouter(connect(state => {
    return {
        userData:state.userData,
        tasksCnt: state.tasks.count,
        changeSimCnt: state.changeSim.count
    };
})(SidebarContent));
